<template>
  <button :class="buttonStyles" :disabled="disabled">
    <span class="sr-only">{{buttonText}}</span>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :class="[
        pos === 'left'
          ? 'transform rotate-180'
          : pos === 'up'
          ? 'transform -rotate-90'
          : pos === 'down'
          ? 'transform rotate-90'
          : '',
      ]"
    >
      <path
        d="M11.0146 3.98535L19.0146 11.9854L11.0146 19.9854"
        stroke-width="3"
        :class="svgStyles"
      />
      <path d="M18 12L2 12" stroke-width="3" :class="svgStyles" />
    </svg>
  </button>
</template>

<script setup lang="ts">
import { toRefs, computed } from "vue";

const props = defineProps<{
  pos: "left" | "right" | "up" | "down";
  classes?: string;
  themeType: "light" | "dark";
  isUmbraco?: boolean;
  disabled?: boolean;
}>();

const { pos, classes, themeType, isUmbraco, disabled } = toRefs(props);

const buttonStyles = computed(() => {
  const hoverColor = disabled.value ? "" : "hover:border-orange";
  const borderColor =
    themeType.value === "light" ? "border-aubergine-20" : "border-white-20";

  return `border-2 ${borderColor} rounded-full w-[52px] h-[52px] flex justify-center items-center group ${hoverColor} linkTransition ${classes?.value}`;
});

const buttonText = computed(() => {
  if (pos.value === "left" || pos.value === "up") return "Go to previous";
  if (pos.value === "right" || pos.value === "down") return "Go to next";
  
  return "";
});

const svgStyles = computed(() => {
  const color =
    themeType.value === "light" && disabled.value
      ? "stroke-aubergine-20"
      : themeType.value === "dark" && disabled.value
      ? "stroke-white-20"
      : themeType.value === "light"
      ? "stroke-aubergine"
      : "stroke-white";

  const hoverColor = disabled.value ? "" : "group-hover:stroke-orange";

  return `${hoverColor} linkTransition ${color}`;
});
</script>
```
